import { antGrey } from '../styles/globalStyles';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Layout from 'antd/lib/layout';
import { setWelcomeModalOptions } from '../../actions/ui';
import { OnboardingCTAs } from '../onboarding/OnboardingCTAs';
import { RootState } from '../../reducers/reducers';
import { selectShouldShowWelcomeModal } from '../../selectors/selectors';

const { Content } = Layout;

const NoAppsComponent: React.FC = () => {
    const dispatch = useDispatch();

    const addAppsVisible = useSelector((state: RootState) => selectShouldShowWelcomeModal(state));

    const addAppClicked = () => {
        dispatch(setWelcomeModalOptions({ shouldShowWelcomeModal: true, shouldDirectlyShowNewAppFlow: true }));
    };

    if (addAppsVisible) {
        return null;
    }

    return (
        <Layout
            style={{
                backgroundColor: antGrey.grey2,
                display: 'flex',
                padding: 48,
            }}
        >
            <Content>
                <OnboardingCTAs onAddAppClicked={addAppClicked} />
            </Content>
        </Layout>
    );
};

export default NoAppsComponent;
